import Head from 'next/head';
import { Col, Container } from 'react-bootstrap';
import RelatedBlogs from '@/components/blog/related_blogs';
import React from 'react';
import { BlogEnum } from '@/types/translations/BlogEnum';
import { SkuEnum } from '@/types/translations/SkuEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import Accordion from 'react-bootstrap/Accordion';
import { SkusBrandContentProps } from '@/types/props/components/skus';

export default function SkusBrandContent({ brandsContent }: SkusBrandContentProps) {
  const { translate: translateBlog } = useTypedTranslation<BlogEnum>('blog');
  const { translate: translateSku } = useTypedTranslation<SkuEnum>('sku');

  return (
    <>
      <Head>
        {/* In the head, not the body: React 18 does not hoist <link>, so a body-level stylesheet
            only starts loading when this component renders. */}
        <link rel="stylesheet" href="/css/brands.css" />
      </Head>
      <div className={'brands_content_box'}>
        <Col className={`brands_latest_articles tw-mt-[60px] tw-bg-customGray tw-py-[60px]`}>
          <Container className="">
            <h2 className={`tw-mb-[15px] tw-text-[24px] tw-font-semibold`}>
              {translateBlog(BlogEnum.latest_articles)}
            </h2>
            <div
              className={`tw-mb-[40px] tw-h-[5px] tw-max-w-[100px] tw-rounded-[20px] tw-bg-custom-gold`}
            ></div>
            <RelatedBlogs blogtitle={''}></RelatedBlogs>
            <PrimaryButtonLink
              href={'/news'}
              className="flex mx-auto font-weight-bold justify-center mt-[25px] px-[60px] w-fit"
            >
              {translateBlog(BlogEnum.all_articles)}
            </PrimaryButtonLink>
          </Container>
        </Col>
        <Container className={'brands_content_content'}>
          <Col className={`mx-auto tw-mt-[60px]`} md={8}>
            <div
              className={`content_first_para`}
              dangerouslySetInnerHTML={{
                __html: brandsContent?.content_first_para || '',
              }}
            ></div>
            <div
              className={`table_content_content tw-my-[30px] tw-rounded-[20px] tw-bg-customGray tw-p-[30px]`}
            >
              <h3 className={`tw-pb-[20px]`}> {translateBlog(BlogEnum.content_table)}</h3>

              <div
                dangerouslySetInnerHTML={{
                  __html: brandsContent?.content_table || '',
                }}
              ></div>
            </div>
            <div
              className={`content_content`}
              dangerouslySetInnerHTML={{
                __html: brandsContent?.content_text || '',
              }}
            ></div>
          </Col>
        </Container>
        <Col className={`faqsection tw-mt-[60px] tw-bg-customGray tw-py-[60px]`}>
          <Container className="">
            <div className="tw-align-items-center tw-mb-[40px] tw-flex tw-justify-between max-sm:tw-flex-col max-sm:tw-text-center">
              <h2>{translateSku(SkuEnum.do_you_have_any_questions)}</h2>
              <PrimaryButtonLink
                href={'mailto:help@spiritory.com'}
                className="d-flex font-weight-bold justify-content-center tw-px-[60px] max-sm:tw-m-auto max-sm:tw-mt-[15px]"
              >
                {translateSku(SkuEnum.contact_us)}
              </PrimaryButtonLink>
            </div>

            <Accordion>
              {brandsContent?.faqs &&
                typeof brandsContent.faqs === 'object' &&
                Object.entries(brandsContent.faqs).map(([key, item], index) => (
                  <Accordion.Item eventKey={`${index}`} key={key}>
                    <Accordion.Header>
                      {item.question} {/* Zugriff auf die `question`-Eigenschaft */}
                    </Accordion.Header>

                    <Accordion.Body>
                      {item.answer} {/* Zugriff auf die `answer`-Eigenschaft */}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </Container>
        </Col>
      </div>
    </>
  );
}
